import react, { useState, useEffect } from "react";
import { authenticateAdminUser } from "./utils";
import BogglerAdmin from './BogglerAdmin';
import AdminDashboardHeader from "./AdminDashboardHeader";

const AuthenticatedRoute = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showAnExpiredTokenModal, setShowAnExpiredTokenModal] = useState(false);

    const showTheExpiredTokenModal = () => {
        setShowAnExpiredTokenModal(true);
    }

    const TheExpiredTokenModal = () => {
        return (
            <div className="modal-overlay">
                <div className="modal">
                    <h2>Session Expired</h2>
                    <p>Your session has expired. Please log in again.</p>
                    <BogglerAdmin fromExpiredTokenModal={true} closeExpiredTokenModal={setShowAnExpiredTokenModal(false)} />
                </div>
            </div>
        );
    }

    useEffect(() => {
        const authenticationData = authenticateAdminUser();
        authenticationData.then(data => {
            if(data) {
                if(data.isLoggedIn !== isLoggedIn) {
                    if(data.isLoggedIn) {
                        setIsLoggedIn(true);
                    } else {
                        setIsLoggedIn(false);
                    }
                }
            }
        });
    }, []);

    return (
        <div>
            <AdminDashboardHeader />
            {showAnExpiredTokenModal && <TheExpiredTokenModal />}
            {react.cloneElement(children, { isLoggedIn, showTheExpiredTokenModal })}
        </div>
    )
}

export default AuthenticatedRoute;